import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconEllipsis = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-6.5 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-6.752.834a1.5 1.5 0 1 0-2.495-1.667 1.5 1.5 0 0 0 2.495 1.667Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconEllipsis);
export default Memo;
